// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import { addToChainAfter, ApiHandlerDiscreteParameter, HasOnComplete } from "@insite/client-framework/HandlerCreator";
import { getPageUrlByType } from "@insite/client-framework/Services/ContentService";
import { GetSessionApiParameter, Session } from "@insite/client-framework/Services/SessionService";
import { chain, DispatchCompleteLoadSession } from "@insite/client-framework/Store/Context/Handlers/LoadSession";

type HandlerType = ApiHandlerDiscreteParameter<
    GetSessionApiParameter & HasOnComplete<{ apiResult: Session }> & { isSessionUpdate?: true },
    GetSessionApiParameter,
    Session
>;

// Another work around to redirect user to the last visited page before signin in
// in case they have a default customer set
export const ShouldRedirectUsingReturnUrl: HandlerType = async props => {
    if (typeof window !== "undefined") {
        const homePageUrl = await getPageUrlByType("HomePage");
        const dashboardUrl = await getPageUrlByType("MyAccountPage");
        const currentPage = window.location.pathname;
        let returnUrl = window.localStorage.getItem("returnUrl") || "";
        const parsedUrl = parseQueryString<{ returnUrl?: string; returnurl?: string }>(returnUrl!);
        returnUrl = parsedUrl?.returnUrl || parsedUrl?.returnurl || "";

        if (
            !props.apiResult.redirectToChangeCustomerPageOnSignIn &&
            returnUrl.length > 0 &&
            props.apiResult.isAuthenticated
        ) {
            localStorage.setItem("returnUrl", "");
            if (props.apiResult.dashboardIsHomepage && returnUrl === homePageUrl) {
                returnUrl = dashboardUrl;
            }
            if (returnUrl?.toLowerCase()?.includes("/signin") || currentPage === returnUrl) {
                return;
            }
            window.location.href = returnUrl;
        }
    }
};

addToChainAfter(chain, DispatchCompleteLoadSession, ShouldRedirectUsingReturnUrl);
